import { api } from 'data/api/api'

import { GetDeliveryOptionChangeRequestDetailsResp } from '../types/response/get-delivery-option-change-request-details-resp'

export const getDeliveryOptionChangeRequestDetails = (shipmentId: number) =>
  api.get<GetDeliveryOptionChangeRequestDetailsResp>(
    `shipments/${shipmentId}/delivery_option_change_request`,
  )
